import { collection, doc, getFirestore, setDoc } from "firebase/firestore";
import 'firebase/firestore'
import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/compat/app";
import { functions } from "../main";
import "firebase/compat/firestore";
import "firebase/compat/functions";

const state = {
  requests: [],
  loading: false
};



const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setLoadedRequests(state, payload) {

    state.requests = payload;
    // console.log('in the setter', state.requests)
  },
  setNewRequest(state, payload) {

    console.log(' request to be added in the setter', payload);

    //add the new booking to the loadedUserBookings list
    state.requests.push(payload)
    // console.log('in the setter', state.requests)


  },
};

const actions = {
  async createRequest(context, payload) {
    //set loading to true
    // context.commit('setLoading', true)

    console.log("createRequest", payload)

    const db = getFirestore();

    const requestRef = doc(collection(db, "requests"));

    await setDoc(requestRef, payload);


  },

  loadRequests({ commit }) {
    console.log('requests are loading');
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      firebase
        .firestore()
        .collection("requests")
        .orderBy("createdAt", "desc")
        .get()
        .then(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            var o = doc.data();
            o.id = doc.id;
            items.push(o);
          });
          console.log('requests: ', items);
          commit("setLoadedRequests", items);
          resolve(items);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
          reject(error);
        });
    });
  },

};

const getters = {
  // requests: state => (state.requests[0] ? state.requests[0] : {}),
  requests(state) {
    return state.requests;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
